import React, { useEffect, useState } from 'react';
import { Popover } from '@mui/material';
import './DateRangeComponent.css';
import BasicDatePicker from '../Datepicker/Datepicker';
import { useSnackBar } from "../../hooks/useSnackBar";



export const DateRangeComponent = ({ label = "Date Range", getDateRange, resetRange }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });
    const { warningMsg } = useSnackBar();
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'date-range-popover' : undefined;

    useEffect(() => {
        // if (dateRange.startDate || dateRange.endDate) 
        if (getDateRange) {
            getDateRange(dateRange);
        }
    }, [dateRange]);

    useEffect(() => {
        if (resetRange) {
            setDateRange({ startDate: null, endDate: null });
        }
    }, [resetRange]);


    return (
        <section className='date-range-component-container'

        >
            <button
                className='date-range-component-btn'
                onClick={handleClick}
            >
                <p>
                    {label}
                </p>
                <p>
                    From : {
                        dateRange?.startDate
                            ? new Date(dateRange.startDate).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit"
                            }).replace(/\//g, "-")
                            : "--"}

                </p>
                {" "}
                <p>
                    To: {
                        dateRange?.endDate
                            ? new Date(dateRange.endDate).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit"
                            }).replace(/\//g, "-")
                            : "--"}
                </p>
                <i className='icon-arrow-down' style={{
                    transition: "var(--transition)",
                    transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                }}></i>
            </button>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                PaperProps={{
                    sx: {
                        width: anchorEl ? anchorEl.offsetWidth : undefined,
                        borderRadius: "var(--button-radius)",
                        padding: "0"
                    }
                }}
            >
                <section className='date-range-component-pickers-container'>
                    <p
                        onClick={
                            () => {
                                setDateRange({ startDate: null, endDate: null });
                            }
                        }
                    >Clear Filters</p>
                      <BasicDatePicker
                    label={"From"}
                    value={dateRange.startDate}
                    onChange={(e) => {
                        const newStartDate = e.$d;
                        if (dateRange.endDate && newStartDate > dateRange.endDate) {
                            warningMsg("Invalid Date", "Start date cannot be later than end date");
                            return;
                        }
                        setDateRange({ ...dateRange, startDate: newStartDate });
                    }}
                    maxDate={dateRange.endDate} 
                />



                     <BasicDatePicker
                    label={"To"}
                    value={dateRange.endDate}
                    onChange={(e) => {
                        const newEndDate = e.$d;
                        if (dateRange.startDate && newEndDate < dateRange.startDate) {
                            warningMsg("Invalid Date", "End date cannot be earlier than start date");
                            return;
                        }
                        setDateRange({ ...dateRange, endDate: newEndDate });
                    }}
                    minDate={dateRange.startDate}
                />

                </section>
            </Popover>
        </section>
    );
};
